import { FaMapMarkerAlt, FaPhone } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import "./contact.css";

const ContactInfo = () => {
  return (
    <div className="contact-info">
      <div className="contact-item">
        <FaPhone className="contact-icon" aria-hidden="true" />
        <div>
          <span>Phone</span>
          <a href="tel:+8801516116383">+880 1516-116383</a>
        </div>
      </div>
      <div className="contact-item">
        <IoMail className="contact-icon" aria-hidden="true" />
        <div>
          <span>Email</span>
          <a href="mailto:shoieb.ctg@gmail.com">shoieb.ctg@gmail.com</a>
        </div>
      </div>
      <div className="contact-item">
        <FaMapMarkerAlt className="contact-icon" aria-hidden="true" />
        <div>
          <span>Location</span>
          <p>Chittagong, Bangladesh</p>
        </div>
      </div>
    </div>
  );
};

export default ContactInfo;
